import { render, staticRenderFns } from "./vis-loading.vue?vue&type=template&id=3ae9f452"
import script from "./vis-loading.vue?vue&type=script&lang=js"
export * from "./vis-loading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports